customElements.whenDefined('shopify-forms-embed').then(() => {
  const observer = new MutationObserver(() => {
    const widgets = document.querySelectorAll('shopify-forms-embed');

    widgets.forEach((widget) => {
      // Skip if already processed
      if (widget.dataset.styled) return;

      const shadowRoot = widget.shadowRoot;
      if (!shadowRoot) return;

      const sheet = new CSSStyleSheet();

      sheet.replaceSync(`
        :host {
          --inline-container-max-width: 600px;
          --form-field-border-radius: 0;
          --form-field-border: 0 0 0 1px var(--color-border);
          --button-padding: var(--button-padding-block) var(--button-padding-inline);
          --button-border-radius: var(--style-border-radius-buttons-primary);
        }

        #form-container-ref [class*='formHeader'] {
          display: flex;
          flex-direction: column;
          gap: 16px;
          margin: 0 0 16px;
        }

        #form-container-ref h2 {
          margin: 0;
          font-size: var(--font-h2--size);
          line-height: var(--font-h2--line-height);
          letter-spacing: var(--font-h2--letter-spacing);
          text-transform: var(--font-h2--case);
        }

        #form-container-ref [class*='formContainer'] {
          margin: 0;
        }

        #form-container-ref form {
          gap: 20px;
          width: 600px;
          max-width: 100%;
          box-sizing: border-box;
        }

        #form-container-ref input[type="checkbox"],
        #form-container-ref input[type="radio"] {
          width: 1rem;
          height: 1rem;
          accent-color: #B0905C;
        }

        #form-container-ref [class*='consentCheckboxContainer'] {
          margin: 0;
          padding: 0;
        }

        #form-container-ref button[type="submit"] {
          background-color: transparent;
          box-shadow: inset 0 0 0 1px var(--button-background-color);
          font-size: var(--font-size--sm);
          line-height: var(--font-paragraph--line-height);
          letter-spacing: var(--letter-spacing-sm);
          text-transform: var(--button-text-case-primary);
        }

        #form-container-ref button[type="submit"]:hover {
          background-color: var(--color-secondary-button-hover-background);
          filter: none;
        }
      `);

      shadowRoot.adoptedStyleSheets.push(sheet);

      // Mark as processed
      widget.dataset.styled = "true";
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});